import { createApiInstance, API_BASE_URL } from './axiosConfig';
import { JsonFile } from '../types';

export class BackupService {
  private api = createApiInstance(`${API_BASE_URL}/json-files/backups`);

  setAuthToken(token: string): void {
    this.api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  removeAuthToken(): void {
    delete this.api.defaults.headers.common['Authorization'];
  }

  async getBackups(): Promise<string[]> {
    const response = await this.api.get('/list');
    return response.data;
  }

  async getBackup(filename: string): Promise<JsonFile> {
    try {
      const response = await this.api.get(`/${filename}`);
      return response.data;
    } catch (error: any) {
      console.error('Error en getBackup:', error);
      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
      }
      throw error;
    }
  }

  async deleteBackup(filename: string): Promise<void> {
    await this.api.delete(`/${filename}`);
  }

  async restoreFromBackup(backupFilename: string, targetFilename?: string): Promise<JsonFile> {
    const response = await this.api.post(`/${backupFilename}/restore`, {
      targetFilename,
    });
    return response.data;
  }
}
